export function quantityFunction() {
    $("<span class=\"quantity-button quantity-up\"><span class=\"plus\"></span></span><span class=\"quantity-button quantity-down\"><span class=\"minuse\"></span></span>").insertAfter(".quantity input");
    
    $(".quantity").each(function () {
        const spinner = $(this);
        const  input = spinner.find("input[type=\"number\"]");
        const  btnUp = spinner.find(".quantity-up");
        const  btnDown = spinner.find(".quantity-down");
        const  min = input.attr("min");
        const  max = input.attr("max") || 100;
        let newVal = 1;
        let oldValue = 1;

        btnUp.on("click", function (e) {
            e.preventDefault();
            oldValue = parseFloat(input.val());
            if (oldValue >= max) {
                newVal = oldValue;
            } else {
                newVal = oldValue + 1;
            }
            spinner.find("input").val(newVal);
            spinner.find("input").trigger("change");
        });

        btnDown.on("click", function () {
            oldValue = parseFloat(input.val());
            if (oldValue <= min) {
                newVal = oldValue;
            } else {
                newVal = oldValue - 1;
            }
            spinner.find("input").val(newVal);
            spinner.find("input").trigger("change");
        });
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/quantityFunction.js